import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../pages/service/shared.service';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputMaskModule } from 'primeng/inputmask';
import { SharedModule } from '@/shared/shared.module';
import { TabsModule } from 'primeng/tabs';
import { StepperModule } from 'primeng/stepper';
import { Menu, MenuModule } from 'primeng/menu';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@/app/pages/service/auth/auth.service';
import { LayoutService } from '@/app/layout/service/layout.service';

@Component({
  standalone: true,
  selector: 'app-login-inativo-dialog',
  imports: [
    CommonModule,
        TableModule,
        ButtonModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        PaginatorModule,
        ProgressSpinnerModule,
        AccordionModule,
        ToggleSwitchModule,
        FloatLabelModule,
        InputMaskModule,
        SharedModule,
        TagModule,
        TabsModule,
        StepperModule,
        MenuModule,
        CheckboxModule,
        DatePickerModule,
        FormsModule
  ],
  providers: [
    SharedService,
    AuthService
  ],
  templateUrl: './login-inativo-dialog.component.html',
  styleUrl: './login-inativo-dialog.component.scss'
})
export class LoginInativoDialogComponent {
  @Input() loginDialog: boolean = false;

  layoutService: LayoutService = inject(LayoutService);

  loading: boolean = false;

  usuario: any = {};

  constructor(private _authService: AuthService, private _messageService: MessageService, private _router: Router) { 
    this._authService.inativo$.subscribe(() => {
      this.usuario = {};
      localStorage.removeItem('access_token');
      this.loginDialog = true;
    });
  }

  login() {
    if (!this.usuario.username || !this.usuario.password) {
      this._messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'E-mail ou senha inválida.',
      });
      return;
    }

    this.loading = true;

    this._authService.login(this.usuario).subscribe({
      next: (data) => {
        this.loading = false;
        localStorage.setItem('access_token', data.accessToken);
        this.carregarUsuario();
      }, error: (err)=> {
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'E-mail ou senha inválida.',
        });
      }
    })
  }

  carregarUsuario() {
    this.loading = true;
    this._authService.usuarioLogado({}).subscribe({
      next: (data) => {
        this.loading = false;
        localStorage.removeItem('userLogged');
        localStorage.setItem('userLogged', JSON.stringify(data));
        this.loginDialog = false;
      }, error: (data) => {
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao tentar carregar o usuário.',
        });
      }
    })
  }

  closeDialog() {
    const accessToken = localStorage.getItem('access_token');
    
    this.loginDialog = false;

    if (!accessToken) this._router.navigate(['/auth/login']);
  }
}
